import React, { useContext, useEffect, useState } from "react";
import { Alert, Dialog, Snackbar } from "../../../../layout";
import { InputSwitch } from "../../../../controls";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../../App";
import { API, action, controller } from "../../../../api/api";
import ViewProd from "../ViewProduct/ViewProd";
import Actions from "./Actions";
import Header from "./Header";
import ProdWidget from "./ProdWidget";
import DateWidget from "./DateWidget";
import DynamicTable from "../../../../layout/DynamicTable/DynamicTable";
import UpdatePrices from "../UpdateMultProd/UpdatePrices";
import UpdateStatus from "../UpdateMultProd/UpdateStatus";
import UpdateBCST from "../UpdateMultProd/UpdateBCST";
import { useFormatPrice } from "hooks";
import { Chip } from "@mui/material";

const Products = () => {
  const navigate = useNavigate();
  const formatPrice = useFormatPrice();
  const { setLoader, access } = useContext(AppContext);
  const [products, setProducts] = useState([]);
  const [tblData, setTblData] = useState([]);
  const [showViewProd, setShowViewProd] = useState(false);
  const [viewProdId, setViewProdId] = useState(0);
  const [showUpdPrice, setShowUpdPrice] = useState(false);
  const [updateBCST, setUpdateBCST] = useState({ open: false, type: "brand" });
  const [showStatusForm, setShowStatusForm] = useState({
    open: false,
    activeProduct: true,
  });

  const [selectedRec, setSelectedRec] = useState({ items: [], all: false });

  const [snackbar, setSnackbar] = useState({
    show: false,
    type: "success",
    msg: "",
  });
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  const handleBCST = (type) => {
    setUpdateBCST({ open: true, type });
  };

  const handleAddEdit = (id) => {
    navigate(`/product_form/${id || ""}`);
  };

  const handleUpdatePrices = () => {
    setShowUpdPrice(true);
  };

  const handleDlt = (id) => {
    setAlert({
      isOpen: true,
      type: "confirmation",
      title: "Are you sure",
      subTitle: "You want to delete this product?",
      onConfirm: () => {
        const onComplete = (res) => {
          if (res) {
            if (res.status === 200) {
              setAlert({
                isOpen: false,
                type: "",
                title: "",
                subTitle: "",
              });
              setSnackbar((j) => ({ ...j, show: true, msg: res.msg }));
              setProducts((x) => [...x.filter((j) => j.id !== res.result.id)]);
            } else
              setAlert({
                isOpen: true,
                type: "warning",
                title: "Warning",
                subTitle: res.msg,
              });
          }
        };
        API(controller.Product).Delete(id, onComplete);
      },
    });
  };

  const handleView = (id) => {
    setViewProdId(id);
    setShowViewProd(true);
  };

  const handleActive = (id) => {
    setLoader(true);
    API(controller.Product + action.ActiveAndInactive).getById(id, (res) => {
      setLoader(false);
      if (res.status === 200)
        setProducts([
          ...products.map((j) =>
            j.id === id ? { ...j, isActive: res.result.isActive } : j
          ),
        ]);
      else console.error("error: ", res.msg);
    });
  };

  const handleStatus = (status) => {
    setShowStatusForm((j) => ({ ...j, open: true, activeProduct: status }));
  };

  useEffect(() => {
    setTblData([
      ...products.map((j) => ({
        ...j,
        date: <DateWidget {...{ date1: j.createDate, date2: j.updateDate }} />,
        rtlPrice: <span className="font-bold"> {formatPrice(j.rtlPrice)}</span>,
        totalInventory: <span className="font-bold"> {j.totalInventory}</span>,
        prod: (
          <ProdWidget
            {...{ imgUrl: j.imgUrl, label: j.label, subtitle: j.prodTypeValue }}
          />
        ),
        active: access?.catalog?.status ? (
          <InputSwitch
            checked={j.isActive}
            onChange={() => handleActive(j.id)}
          />
        ) : j.isActive ? (
          <Chip
            label="active"
            color="success"
            className="!text-[12] shadow-xl !font-bold tracking-wider uppercase"
          />
        ) : (
          <Chip
            label="Inactive"
            color="error"
            className="!text-[12] shadow-xl !font-bold tracking-wider uppercase"
          />
        ),
      })),
    ]);

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products]);

  return (
    <>
      <DynamicTable
        records={tblData}
        setRecords={setProducts}
        endpointKey={controller.Product + action.GetAllByOrgPg}
        ActionComp={(param) => (
          <Actions {...{ param, handleView, handleAddEdit, handleDlt }} />
        )}
        enableSelect={
          (access?.catalog?.edit || access?.catalog?.delete) && true
        }
        selected={selectedRec}
        setSelected={setSelectedRec}
        HeaderComp={() => (
          <Header
            {...{
              handleAddEdit,
              selectedRec,
              handleUpdatePrices,
              handleStatus,
              setAlert,
              handleBCST,
            }}
          />
        )}
        headers={[
          { id: "actions", label: "Actions" },
          { id: "active", label: "Active" },
          { id: "prod", label: "Product" },
          { id: "totalInventory", label: "Inventory" },
          {
            id: "rtlPrice",
            label: <span className="flex w-max">Retail Price</span>,
          },
          { id: "supplierNames", label: "Supplier" },
          { id: "date", label: "Date" },
        ]}
      />

      {/* View Product */}
      {showViewProd && (
        <Dialog show={showViewProd} onClose={false} maxWidth="lg">
          <ViewProd {...{ setShowForm: setShowViewProd, id: viewProdId }} />
        </Dialog>
      )}

      {/* Update Prices */}
      {showUpdPrice && (
        <Dialog show={showUpdPrice} onClose={false} maxWidth="lg">
          <UpdatePrices {...{ setShowForm: setShowUpdPrice, selectedRec }} />
        </Dialog>
      )}

      {/* Update Product Status (Active or Deactive) */}
      {showStatusForm?.open && (
        <Dialog show={showStatusForm?.open} onClose={false} maxWidth="sm">
          <UpdateStatus
            {...{
              setShowForm: setShowStatusForm,
              showForm: showStatusForm,
              selectedRec,
            }}
          />
        </Dialog>
      )}

      {/* Update Selected Products Brand */}
      {updateBCST?.open && (
        <Dialog show={updateBCST?.open} onClose={false} maxWidth="xs">
          <UpdateBCST
            {...{ setUpdateBCST, updateBCST, selectedRec, setSelectedRec }}
          />
        </Dialog>
      )}

      {/* Alert  */}
      {alert.isOpen && <Alert alert={alert} setAlert={setAlert} />}
      {/* Alert  */}
      <Snackbar {...{ snackbar, setSnackbar }} />
    </>
  );
};

export default Products;
